import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Icons for expand/collapse
import "./Advice.css"; // FAQ styles
import { advice } from "../content"; // Import FAQ data

const Advice = () => {
  return (
    <div className="fade-in">
      <div className="container">

        {/* Hero image section */}
        <div className="advice-image">
          <div className="hero-text content-wrapper">
            <h1 className="title">Advice from us</h1>
          </div>
        </div>

        {/* FAQ List */}
        <div className="advice-list">
          {advice.map((item, index) => (
            <AdviceItem key={index} question={item.question} answer={item.answer} />
          ))}
        </div>

      </div>
    </div>
  );
};

// Each individual FAQ item with toggle logic
const AdviceItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false); // Track open/close state

  const toggleOpen = () => {
    setIsOpen(!isOpen); // Toggle state
  };

  return (
    <div className="advice-item">
      <div className="advice-question" onClick={toggleOpen}>
        <span>{question}</span>
        {/* Display appropriate icon depending on toggle state */}
        {isOpen ? <FaChevronUp className="advice-icon" /> : <FaChevronDown className="advice-icon" />}
      </div>
      {/* Show answer only if open; use dangerouslySetInnerHTML for links */}
      {isOpen && (
        <div className="advice-answer" dangerouslySetInnerHTML={{ __html: answer }} />
      )}
    </div>
  );
};

export default Advice;
